export const DELIVERY_POINT_PRODUCT_ID = 1000002;
